import React from "react";

import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import Google from "shared/assets/Google.svg";
import Microsoft from "shared/assets/Microsoft.svg";
import PayPal from "shared/assets/PayPal.svg";
import Yahoo from "shared/assets/Yahoo.svg";
import Notification from "shared/components/Notification";
import { PROVIDER_URL } from "shared/graphql/mutations";
import { DEFAULT_VALUES, NAME_SPACES } from "shared/locals/constants";
import { openInSameTab } from "utils/helpers/openTab";

const External = () => {
  const { t: tError } = useTranslation(NAME_SPACES.ERRORS);

  const [getProviderUrl] = useMutation(PROVIDER_URL, {
    onCompleted: async ({ getProviderUrl: url }) => {
      openInSameTab(url);
    },
    onError: () => {
      Notification.error({
        duration: DEFAULT_VALUES.NOTIFICATION_DURATION,
        message: tError("GENERIC"),
      });
    },
  });

  const onClick = (provider) => () => {
    getProviderUrl({ variables: { provider } });
  };

  return (
    <div className={"spaced-row"}>
      <img src={Google} alt="" onClick={onClick("google")} />
      <img src={Microsoft} alt="" onClick={onClick("microsoft")} />
      <img src={Yahoo} alt="" onClick={onClick("yahoo")} />
      <img src={PayPal} alt="" onClick={onClick("paypal")} />
    </div>
  );
};

export default External;
